import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API, formatApiError } from "../context/AuthContext";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

export default function ResetPassword() {
  const { t } = useLanguage();
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState({ new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.new_password.length < 8) { toast.error(t("La password deve avere almeno 8 caratteri")); return; }
    if (pwd.new_password !== pwd.confirm) { toast.error(t("Le password non coincidono")); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: pwd.new_password });
      toast.success(t("Password reimpostata. Accedi con la nuova password."));
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || t("Errore"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] max-w-[520px] mx-auto px-6 py-24">
      <Seo title="Reimposta password" path={`/reset-password/${token || ""}`} noindex />
      <form onSubmit={submit}>
        <div className="overline text-stone-500">{t("Recupero accesso")}</div>
        <h1 className="font-serif text-4xl tracking-tighter mt-2">{t("Nuova password.")}</h1>
        <p className="mt-4 text-stone-600 text-sm">{t("Scegli una password forte di almeno 8 caratteri.")}</p>
        <div className="mt-8 flex flex-col gap-6">
          <label className="flex flex-col">
            <span className="overline text-stone-500 mb-2">{t("Nuova password")}</span>
            <input data-testid="reset-new-pwd" type="password" required minLength={8} value={pwd.new_password} onChange={e => setPwd(p => ({...p, new_password: e.target.value}))} className="border-b border-stone-300 bg-transparent py-3 focus:border-stone-900 focus:outline-none" />
          </label>
          <label className="flex flex-col">
            <span className="overline text-stone-500 mb-2">{t("Conferma password")}</span>
            <input data-testid="reset-confirm-pwd" type="password" required minLength={8} value={pwd.confirm} onChange={e => setPwd(p => ({...p, confirm: e.target.value}))} className="border-b border-stone-300 bg-transparent py-3 focus:border-stone-900 focus:outline-none" />
          </label>
          <button data-testid="reset-submit" disabled={busy} className="mt-4 w-full text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors disabled:opacity-50">{busy ? "…" : t("Reimposta password")}</button>
        </div>
        <div className="mt-6 text-sm text-stone-600 text-center">
          <Link to="/login" className="underline-hover text-[#8C3A3A]">{t("Torna al login")}</Link>
        </div>
      </form>
    </div>
  );
}
